﻿import './sections.css'
const CASES = [
  {
    tag: 'Integration Success',
    title: 'How a Global Professional Services Firm Powers Agricultural CRM with PossoBuild AI',
    stats: [
      { n: 'Enterprise-Grade', l: 'Agri-business clients' },
      { n: 'Global', l: 'Big 4 consulting firm' },
      { n: 'Embedded Intelligence', l: 'CRM integration' }
    ],
    challenge: 'A leading global professional services firm needed to enhance their  enterprise platform serving agricultural businesses. Their clients required sophisticated talent management capabilities within the existing CRM ecosystem.',
    solution: "PossoBuild's API-first architecture enabled seamless integration with their CRM platform. Our AI-powered hiring, development, and assessment tools now serve as the embedded talent intelligence layer for thousands of agricultural businesses.",
    results: '✓ Integrated with enterprise CRM at enterprise scale\n✓ White-labeled deployment across global agricultural sector\n✓ Scalable AI infrastructure supporting multinational operations\n✓ Trusted by Big 4 professional services standards'
  },
  {
    tag: 'Enterprise Learning',
    title: 'Fortune 100 IT Leader Powers Training Validation with PossoBuild',
    stats: [
      { n: 'Enterprise Scale', l: 'Corporate learners' },
      { n: 'Fortune 100', l: 'IT services company' },
      { n: 'L&D; Transformation', l: 'Learning division' }
    ],
    challenge: 'A Fortune 100 IT services company\'s learning division needed to validate training effectiveness across enterprise-scale corporate learning programs. Traditional assessments couldn\'t scale, and completion rates didn\'t prove actual learning.',
    solution: "PossoBuild's SmartAssess became the validation engine for their enterprise learning platform. Our conversational AI assessments now measure actual competency development across their entire corporate training ecosystem.",
    results: '✓ Powers training validation at enterprise scale\n✓ Integrated with enterprise L&D platform\n✓ Conversational AI assessments at enterprise scale\n✓ Trusted by global IT services leader'
  }
]
export default function CaseStudiesSection() {
  return (
    <section className="case-studies-section section">
      <div className="container">
        <p className="section-eyebrow">Enterprise Success Stories</p>
        <h2 className="section-title">Integration Success & Enterprise Learning</h2>
        <p className="section-subtitle">How leading organizations power talent intelligence and training validation with PossoBuild.</p>
        <div className="case-studies-grid">
          {CASES.map(c => (
            <div key={c.tag} className="case-study-card">
              <span className="case-study-tag">{c.tag}</span>
              <h3 className="case-study-title">{c.title}</h3>
              <div className="case-study-stats">
                {c.stats.map(s => (
                  <div key={s.l} className="stat-badge">
                    <span className="stat-number">{s.n}</span>
                    <span className="stat-label">{s.l}</span>
                  </div>
                ))}
              </div>
              <div className="case-study-section">
                <h4>The Challenge</h4>
                <p style={{ lineHeight: 1.7 }}>{c.challenge}</p>
              </div>
              <div className="case-study-section">
                <h4>The Solution</h4>
                <p style={{ lineHeight: 1.7 }}>{c.solution}</p>
              </div>
              <div className="case-study-section">
                <h4>The Results</h4>
                <p style={{ lineHeight: 1.7 }}>{c.results.split('\n').map((line, idx) => (<span key={idx}>{line}<br /></span>))}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
